import React from 'react'
import { Heading, Box } from 'theme-ui'

const prettyPrintDay = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday'
}

const formatTime = str => {
  var time = str.split(':')
  var amORpm = ' pm'

  if (time[0] < 12) amORpm = ' am'

  if (time[0] > 12) time[0] -= 12
  else if (time[0] == 0) time[0] = 12

  return time[0] + ':' + time[1] + amORpm
}

const HoursDisplay = ({ hours, variant }) => {
  console.log(variant)
  const days = Object.keys(hours)

  // Function that builds an array of all hour labels for business and filters out the duplicates
  const uniqueHourLabels = days
    .map(day => hours[day].map(hourBlock => hourBlock.name))
    .flat()
    .filter((label, idx, arr) => arr.indexOf(label) === idx)

  const buildHoursObject = uniqueHourLabels.reduce((acc, label) => {
    // If there is no label yet in the object, add it

    if (!acc[label]) {
      // Assign the object key to

      acc[label] = []
    }

    // If there IS a label already inside of the acc, we must then begin populating it with respected hours

    if (acc[label]) {
      acc[label] = [
        ...days
          .map(day =>
            hours[day]
              .filter(hourBlock => hourBlock.name === label)
              .map(hourBlock => hourBlock)
              .flat()
              .map(el => ({
                ...el,
                day: prettyPrintDay[day]
              }))
          )
          .flat()
      ]
    }
    return acc
  }, {})

  const combineEqualHours = hours => {
    if (hours.length === 1) {
      return [
        {
          [hours[0].name]: {
            day: hours.map(({ day }) => day),
            open: hours[0].open,
            close: hours[0].close,
            name: hours[0].name
          }
        }
      ]
    } else {
      return hours.reduce((acc, cur) => {
        if (!acc.length) {
          acc[0] = {
            [cur.name]: [
              {
                day: [cur.day],
                open: cur.open,
                close: cur.close,
                name: cur.name
              }
            ]
          }
        } else {
          if (acc[0][cur.name].some(el => el.close === cur.close && el.open === cur.open)) {
            const found = acc[0][cur.name].find(el => el.open === cur.open && el.close === cur.close)
            found.day.push(cur.day)
          } else {
            acc[0][cur.name].push({
              day: [cur.day],
              open: cur.open,
              close: cur.close,
              name: cur.name
            })
          }
        }
        // return an array with the correct keys
        return acc
      }, [])
    }
  }

  const combineSimilarHours = () => {
    const hourTypes = Object.keys(buildHoursObject)
    const hoursFromObject = hourTypes.map(label => buildHoursObject[label].map(hours => hours))

    return hoursFromObject.map(hourObj => combineEqualHours(hourObj)[0])
  }
  const renderFormattedHours = () => {
    const hourTypes = Object.keys(combineSimilarHours())

    const handleSpecialCase = days => {
      if (days.length === 7) {
        return (
          <Box variant={`${variant}.day`} as="span" className="day">
            Every day
          </Box>
        )
      }
      if (
        days.includes('Monday') &&
        days.includes('Tuesday') &&
        days.includes('Wednesday') &&
        days.includes('Thursday') &&
        days.includes('Sunday')
      ) {
        return 'Sunday - Thursday'
      }
      return false
    }

    if (hourTypes.length === 0) {
      return (
        <Box variant={`${variant}.closed`} className="closed">
          closed
        </Box>
      )
    } else {
      return hourTypes.map(label => {
        const hourWithLabel = combineSimilarHours()[label]
        const hourTitle = Object.keys(hourWithLabel)[0]
        const abc = hourWithLabel[hourTitle]

        return (
          <>
            <Heading as="h4" variant={`${variant}.typelabel`} className="typelabel">
              {hourTitle === 'null' ? '' : hourTitle}
            </Heading>

            {Array.isArray(abc) ? (
              <>
                {abc.map((obj, idx) => (
                  <React.Fragment key={`${obj.day}-${idx}`}>
                    <Box variant={`${variant}.dayContainer`} className="dayContainer" key={`${obj.day}-${idx}`}>
                      {handleSpecialCase(obj.day)
                        ? handleSpecialCase(obj.day)
                        : obj.day.map((day, idx) => (
                            <span className="day text-md" key={`${day}-${idx}-2`}>
                              {day}
                              {obj.day.length - 1 === idx ? ':' : ','}{' '}
                            </span>
                          ))}
                      <Box as="p" variant={`${variant}.time`} className="time">
                        <span>{formatTime(obj.open)} - </span>
                        <span>{formatTime(obj.close)} </span>
                      </Box>
                    </Box>
                  </React.Fragment>
                ))}
              </>
            ) : (
              ''
            )}
          </>
        )
      })
    }
  }

  return (
    <Box variant={`${variant}.innerHoursContainer`} className="innerHoursContainer">
      {renderFormattedHours()}
    </Box>
  )
}

export default HoursDisplay
